module.exports = __webpack_public_path__ + "img/geolim.17a58b94.png";